import { Skeleton, Stack } from '@mui/material';
import { useLocalStorage } from '@rehooks/local-storage';
import React from 'react';

const ExpandedNavWidth = '245px';
const FocusModeNavWidth = '41px';

const PrimaryIconSkeleton = () => {
  return (
    <Skeleton
      variant="rectangular"
      width={24}
      height={24}
      sx={{ borderRadius: 1 }}
    />
  );
};

const AppNameSkeleton = () => {
  return (
    <Skeleton
      variant="rectangular"
      width={120}
      height={24}
      sx={{ borderRadius: 1 }}
    />
  );
};

const PrimaryNavItemSkeleton = () => {
  return (
    <Skeleton
      variant="rectangular"
      width={180}
      height={24}
      sx={{ borderRadius: 1 }}
    />
  );
};

interface NavigationLoadingSkeletonProps {
  height: string;
  top: string;
}

const FocusModeSkeleton = ({ height, top }: NavigationLoadingSkeletonProps) => {
  return (
    <div
      style={{
        width: FocusModeNavWidth,
        height,
        top,
        position: 'sticky',
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Stack direction="column" spacing={3} sx={{ pt: 2 }}>
        <PrimaryIconSkeleton />
        <PrimaryIconSkeleton />
      </Stack>
    </div>
  );
};

const ExpandModeSkeleton = ({
  height,
  top,
}: NavigationLoadingSkeletonProps) => {
  return (
    <div
      style={{
        width: ExpandedNavWidth,
        height,
        top,
        position: 'sticky',
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'row',
      }}
    >
      <FocusModeSkeleton height={height} top={top} />
      <Stack direction="column" spacing={3} sx={{ py: 2, px: 1 }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <AppNameSkeleton />
          <PrimaryIconSkeleton />
        </div>
        <Stack direction="column" spacing={1}>
          <Skeleton
            variant="rectangular"
            width={180}
            height={70}
            sx={{ borderRadius: 1 }}
          />
          {Array.from({ length: 5 }).map((_, index) => (
            <PrimaryNavItemSkeleton key={index} />
          ))}
        </Stack>
      </Stack>
    </div>
  );
};

export const NavigationLoadingSkeleton = ({
  height,
  top,
}: NavigationLoadingSkeletonProps) => {
  const [isNavigationCollapsed] = useLocalStorage<boolean>(
    'ZGlobalNavigationDrawerClosed',
    false,
  );
  return isNavigationCollapsed ? (
    <FocusModeSkeleton height={height} top={top} />
  ) : (
    <ExpandModeSkeleton height={height} top={top} />
  );
};
